import { Card, Col, message, Row } from 'antd';
import React, { Component } from 'react';
import DescriptionList from '@comm/DescriptionList';
import { BackBtn } from '@comm/BackBtn';
import { queryReceiptInfo } from '@api/finance/receipt';

const { Description } = DescriptionList;

class PageOpen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    this.getReceiptInfo();
  }

  getReceiptInfo = () => {
    queryReceiptInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data } = this.state;
    return (
      <div className="form-open">
        <Row style={{ paddingBottom: '20px' }}>
          <Col span={13}>
            <BackBtn />
          </Col>
        </Row>
        <Card title="公司回单卡信息">
          <DescriptionList size="large" col={2}>
            <Description term="公司名称">{data.compName}元</Description>
            <Description term="开户行">{data.bankName}</Description>
            <Description term="账号">{data.bankBook}</Description>
            <Description term="密码">{data.passwd}</Description>
            <Description term="备注">{data.remark}</Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default PageOpen;



// WEBPACK FOOTER //
// ./src/components/finance/receipt/PageOpen.js